/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { connect } from 'react-redux';
import { closeModal, switchModal } from '../../actions';
import X from '../../assets/login/x.svg';

const OneMore = (props) => {
  return (
    <div className="modal one-more-thing-background">
      <img onClick={props.closeModal} className="x-icon" src={X} alt="x" />
      <h2 className="sign-in-header">
        One More Thing!
      </h2>
      <div className="one-more-thing-body">
        <p>
          Before accessing your first survey, we need you to create an account.
        </p>
        <input type="button" value="Next" className="sign-in-button" onClick={() => props.switchModal('SignIn')} />
      </div>
    </div>
  );
};

export default connect(null, { closeModal, switchModal })(OneMore);
